<template>
    <div class="cpo-footer">
        <!-- <pre v-if="content" v-text="content"></pre> -->
        
        <div class="cpo-footer--pattern"></div>
        <div class="cpo-footer--root">
            <a :href="content.path" class="cpo-footer--link" v-text="content.label"
                    target="_blank" rel="noopener noreferrer"></a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            content: Object,
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?73d6f8f2